module.exports = __webpack_public_path__ + "img/vet_nurse_introduction.a3e6f301.jpg";